import { Grid } from '@mui/material';
import React, { Fragment } from 'react';
import ProductIssueFormView from '../../../components/inventory/create/product_issue/ProductIssueFormView';
import ProductIssueListView from '../../../components/inventory/create/product_issue/ProductIssueListView';
import useFetchData from '../../../helpers/useFetch';
import AppURL from '../../../constants/AppURL';

const InventoryProductIssueCreateView = () => {
    const { data, loading, error, refetch } = useFetchData(AppURL.InventoryURL + "inventory/product/master/options/list/view/");
    const handleFormSuccess = (): void => {
        refetch();
    };
    return (
        <Fragment>
            <Grid container spacing={3}>
                <Grid item xl={4} md={4} sm={12} xs={12} lg={4}>
                    <ProductIssueFormView loading={loading} data={data} />
                </Grid>
                <Grid item xl={8} md={8} sm={12} xs={12} lg={8}>
                    <ProductIssueListView />
                </Grid>
            </Grid>
        </Fragment>
    )
}

export default InventoryProductIssueCreateView